import { IHeadCell } from 'features/common/types';

export {
	serviceListFilters as advancedListFilters,
	serviceListHeaderCells,
	transformServiceValue,
} from '../SaleOrderServiceList/constants';

export const QUICK_FILTER_KEYS = ['reference', 'tariffProviderFantasyName', 'saleOrderDealId', 'serviceType'];

export const OPTIONAL_COLUMN_FIELDS = new Set([
	'saleOrderIsBitrixDeal',
	'agencyId',
	'voucherNotes',
	'internalNotes',
	'created',
	'createdBy',
	'updated',
	'updatedBy',
]);

export const DEFAULT_VISIBLE_COLUMNS: IHeadCell[] = [
	{ field: 'id', sortable: true, headerName: 'ID' },
	{ field: 'saleOrderId', sortable: true, headerName: 'ID de SaleOrder' },
	{ field: 'serviceType', sortable: true, headerName: 'Tipo' },
	{ field: 'reference', sortable: true, headerName: 'Referencia' },
	{ field: 'saleOrderDealId', sortable: true, headerName: 'Caso' },
	{ field: 'tariffProviderFantasyName', sortable: true, headerName: 'Proveedor' },
	{ field: 'paymentDateToProvider', sortable: true, headerName: 'Pago proveedor' },
	{ field: 'totalCostMainCurrency', sortable: true, headerName: 'Costo' },
	{ field: 'totalSaleAmountMainCurrency', sortable: true, headerName: 'Venta' },
	{ field: 'minStartDate', sortable: true, headerName: 'Inicio' },
	{ field: 'maxEndDate', sortable: true, headerName: 'Fin' },
	{ field: 'enable', sortable: true, headerName: 'Activo' },
];
